import React, { useState } from "react"
import { Container } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/GotvV2Form.styles"
import { CampaignTitleSubtitle } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CampaignTitleSubtitle/CampaignTitleSubtitle"
import { shouldShowUserInfoUpdateBlock } from "QuorumGrassroots/campaign-forms/helpers"
import UserInfoUpdateBlock from "QuorumGrassroots/campaign-forms/components/ReusableForms/UserInfoUpdateBlock"
import {
    GotvCampaignFooter,
    DEFAULT_SOCIAL_HEADER,
} from "QuorumGrassroots/widgets/GotvCampaignFooter/GotvCampaignFooter"
import { useGotvSocialSharing } from "QuorumGrassroots/widgets/GotvCampaignFooter/useGotvSocialSharing"
import { CountdownTimer } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CountdownTimer/CountdownTimer"
import { LandingPage } from "./components/LandingPage/LandingPage"
import { Campaign } from "@/types/djangio"

interface GotvV2FormProps {
    campaign: Campaign
    t: (key: string) => string
    uniqueWidgetId: string
    isSubmitting?: boolean
    postGrassrootsSupporterAction: (payload: any) => void
    styledButtonText: string
}

export const GotvV2Form: React.FC<GotvV2FormProps> = ({
    campaign,
    t,
    uniqueWidgetId,
    isSubmitting,
    postGrassrootsSupporterAction,
    styledButtonText,
}) => {
    const [showSupporterUpdate, setShowSupporterUpdate] = useState(false)

    const socialPlatforms = useGotvSocialSharing({
        socialMediaPlatforms: campaign.social_media_platforms,
        shareUrl: window.location.href,
        shareText: campaign.social_share_text || `Help ${campaign.name} get out the vote!`,
        imageUrl: campaign.social_image_url,
    })

    const targetDate = new Date(2026, 9, 21, 20, 0, 0)

    return (
        <Container className="gotv-v2-campaign-main">
            <CampaignTitleSubtitle campaign={campaign} />

            {shouldShowUserInfoUpdateBlock() && (
                <UserInfoUpdateBlock
                    campaign={campaign}
                    uniqueWidgetId={uniqueWidgetId}
                    onSupporterFormToggle={setShowSupporterUpdate}
                />
            )}
            {!showSupporterUpdate && (
                <>
                    <CountdownTimer targetDate={targetDate} />
                    <LandingPage />
                    <GotvCampaignFooter
                        socialPlatforms={socialPlatforms}
                        socialHeading={campaign.social_header || DEFAULT_SOCIAL_HEADER}
                    />
                </>
            )}
        </Container>
    )
}
